import { useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import $ from "jquery";

export default function ForgetPassword() {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'
  const [loading, setloading] = useState(false);
  const [successMsg, setsuccessMsg] = useState(null);
  const [errMsg, seterrMsg] = useState(null);
  const [errReset, seterrReset] = useState(null);

  const [mail, setmail] = useState("");
  const [flag, setflag] = useState(false);
  let navigate = useNavigate();

  // function to get email from user to send user password
  async function forgetPass(value) {
    setloading(true);
    try {
      let data = await axios.post(
        `${baseURL}/api/v1/auth/forgotPasswords`,
        value
      );

      if (data.status === 200) {
        setsuccessMsg(data.data.message);
        setloading(false);
        $(".done").fadeIn(300, () => {
          setTimeout(() => {
            $(".done").fadeOut(300, setflag(true));
          }, 3000);
        });
      }
    } catch (error) {
      seterrMsg(error.response.data.message);
      setloading(false);
      $(".err").fadeIn(300, () => {
        setTimeout(() => {
          $(".err").fadeOut(300);
        }, 3000);
      });
    }
  }

  // validate entrie email
  let validationSchema = Yup.object({
    email: Yup.string()
      .required("Email is Required")
      .email("Invalid email address *exemple@yyy.zzz"),
  });
  let formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: function (value) {
      setmail(value);
      forgetPass(value);
    },
  });

  // Reset Password
  async function resetPass(value) {
    setloading(true);
    try {
      let data = await axios.post(
        `${baseURL}/api/v1/auth/verifyResetCode`,
        value
      );
      if (data.status === 200) setloading(false);
      navigate("/resetPassword");
    } catch (error) {
      seterrReset(error.response.data.message);
      setloading(false);
      $(".errCode").fadeIn(300, () => {
        setTimeout(() => {
          $(".errCode").fadeOut(300);
        }, 3000);
      });
    }
  }

  let formik1 = useFormik({
    initialValues: {
      resetCode: "",
    },
    onSubmit: resetPass,
  });

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Forget Password</title>
      </Helmet>

      {/* Incase Flag show Verfication part else show the required emails */}
      {flag ? (
        <div className=" w-75 mx-auto py-4 ">
          <h3 className=" mb-3">Verification required</h3>
          <p className="alert alert-warning">
            To continue, complete this verification step. we’ve sent a code to
            your email{" "}
            <span
              className="fa-fade text-main"
              style={{
                "--fa-animation-duration": "2s",
                "--fa-fade-opacity": 0.6,
              }}
            >
              {mail.email}
            </span>
            . Please enter it below.
          </p>
          <form onSubmit={formik1.handleSubmit}>
            <label htmlFor="resetCode">Enter verification Code: </label>
            <input
              onChange={formik1.handleChange}
              onBlur={formik1.handleBlur}
              value={formik1.values.resetCode}
              type="text"
              name="resetCode"
              id="resetCode"
              className=" form-control mb-2"
            />
            {formik1.errors.resetCode && formik1.touched.resetCode ? (
              <div className=" alert alert-danger">
                {formik1.errors.resetCode}
              </div>
            ) : null}
            <div
              style={{ display: "none" }}
              className="alert alert-danger errCode"
            >
              {errReset}
            </div>
            <div
              style={{ display: "none" }}
              className="alert alert-success doneCode"
            >
              Done
            </div>
            {loading ? (
              <button className="btn bg-main text-white mt-1" type="button">
                {" "}
                <i className="fa-solid fa-spinner fa-spin"></i>{" "}
              </button>
            ) : (
              <button
                disabled={!(formik1.isValid && formik1.dirty)}
                className="btn bg-main text-white mt-1"
                type="submit"
              >
                Continue{" "}
              </button>
            )}
          </form>
          <Link className="d-block mt-2 hoveringClick" to="/register">
            Do you have an account? Create account
          </Link>
        </div>
      ) : (
        <div className=" w-75 mx-auto py-4 ">
          <h3 className=" mb-3">Password assistance</h3>
          <p className="alert alert-warning">
            Enter the email address or mobile phone number associated with your
            Fresh Cart account
          </p>

          <form onSubmit={formik.handleSubmit}>
            <label htmlFor="email">Email</label>
            <input
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              type="email"
              name="email"
              id="email"
              className=" form-control mb-2"
            />
            {formik.errors.email && formik.touched.email ? (
              <div className=" alert alert-danger">{formik.errors.email}</div>
            ) : null}

            <div style={{ display: "none" }} className="alert alert-danger err">
              {errMsg}
            </div>
            <div
              style={{ display: "none" }}
              className="alert alert-success done"
            >
              {successMsg} <i className="fa-solid fa-check"></i> <br /> Check
              Your mail inbox
            </div>
            {loading ? (
              <button className="btn bg-main text-white mt-1" type="button">
                {" "}
                <i className="fa-solid fa-spinner fa-spin"></i>{" "}
              </button>
            ) : (
              <button
                disabled={!(formik.isValid && formik.dirty)}
                className="btn bg-main text-white mt-1"
                type="submit"
              >
                Continue{" "}
              </button>
            )}
          </form>
          <Link className="d-block mt-2 hoveringClick" to="/register">
            Do you have an account? Create account
          </Link>
        </div>
      )}
    </>
  );
}
